import { render } from "./BaseRadio.vue?vue&type=template&id=156409cc"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"
script.render = render

export default script